import 'fancybox-core';

const $reviews = $('.product-reviews');

if ($reviews.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    const $carousel = $('.carousel', $reviews);
    const $btnReview = $('.btn-review');
    const $reviewScroll = $('.review-scroll');

    if ($carousel.find('article').length > 1) {
      $carousel.slick({
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        draggable: true,
        infinite: true,
        /* eslint-disable max-len */
        nextArrow:
          '<button class="slick-next" type="button"><span class="sr-only">Previous</span></i></button>',
        prevArrow:
          '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
        /* eslint-enable max-len */
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
      });
    }

    $btnReview.fancybox({
      autoDimensions: false,
      autoSize: false,
      parent: 'form:first',
      type: 'inline',
      width: '100%',
      height: 'auto',
      maxWidth: 750,
      fitToView: false,
      tpl: {
        closeBtn: `
          <a title="Close"
             class="fancybox-item fancybox-close review-close-btn"
             href="javascript:;">
          </a>
        `,
      },
    });

    $reviewScroll.click(e => {
      e.preventDefault();

      const reviewTab = $(".tabbed-area__tab[data-target='tab-content-reviews']");
      if (reviewTab.length) {
        reviewTab.first().click();
      }

      const offset = $('header').height();
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $('.product-reviews').offset().top - offset,
          },
          900,
          'swing',
        );
    });
  };

  const endRequestHandler = function endRequestHandler() {
    $.fancybox.update();
  };

  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(endRequestHandler);

  self.initialise();
}
